const specialCharacters = [
  'e',
  'E',
  '+',
  '-',
  '@',
  '!',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '(',
  ')',
  '_',
  '-',
  '+',
  '=',
  '{',
  '}',
  '[',
  ']',
  ':',
  ';',
  '<',
  '>',
  ',',
  '.',
  '?',
  '|',
  '\\',
  '/',
  '~',
  '`',
  "'",
  '"',
];

const alphabetCharacters = Array.from({ length: 26 }, (_, i) =>
  String.fromCharCode('a'.charCodeAt(0) + i)
).concat(
  Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode('A'.charCodeAt(0) + i)
  )
);

const allowedCharacters = specialCharacters.concat(alphabetCharacters);

export default allowedCharacters;
